import { useRef, useState } from 'react'
import { IoMdClose } from 'react-icons/io'
import { RiVideoFill } from 'react-icons/ri'

import { VideoPlayer } from 'src/components/atoms/VideoPlayer'

interface VideoDialogProps {
  resource: string
  name: string
}

export const VideoDialog = ({ resource, name }: VideoDialogProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  const openDialog = () => {
    dialogRef.current?.showModal()
    setIsOpen(true)
  }

  const closeDialog = () => {
    dialogRef.current?.close()
    setIsOpen(false)
  }

  return (
    <>
      <button
        type='button'
        onClick={openDialog}
        className='flex items-center gap-2 hover:transition hover:scale-110'
      >
        <span className='bg-white h-8 w-8'>
          <RiVideoFill className='text-tertiary h-12 w-12 -ml-2 -mt-2' />
        </span>
      </button>

      <dialog
        ref={dialogRef}
        className='rounded-lg shadow-xl backdrop:bg-black/50 p-6 max-w-2xl w-full'
      >
        <div className='flex justify-between items-center mb-4'>
          <h2 className='text-xl font-bold'>{name}</h2>
          <button
            type='button'
            onClick={closeDialog}
            className='text-gray-500 hover:text-gray-700 text-2xl'
          >
            <IoMdClose />
          </button>
        </div>

        <VideoPlayer source={resource} _type='video' playing={isOpen} />
      </dialog>
    </>
  )
}
